const DownArrowIcon = ({
  titleId = "downArrowIconTitle",
  className = ""
}: {
  titleId?: string;
  className?: string;
}) => {
  return <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 0 24 24' width='24px' fill='currentColor' className={className} role='img' aria-labelledby={titleId} data-sentry-element="svg" data-sentry-component="DownArrowIcon" data-sentry-source-file="DownArrow.tsx">
      <title id={titleId}>Down Arrow Icon</title>
      <path d='M24 24H0V0h24v24z' fill='none' opacity='.87' data-sentry-element="path" data-sentry-source-file="DownArrow.tsx" />
      <path d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z' data-sentry-element="path" data-sentry-source-file="DownArrow.tsx" />
    </svg>;
};
export default DownArrowIcon;